import React from 'react';
import { CheckCircle, Award, Users, TrendingUp } from 'lucide-react';

export const About = () => {
  const highlights = [
    { icon: Award, text: '30+ Years of Industry Expertise' },
    { icon: Users, text: '500+ Skilled Professionals' },
    { icon: TrendingUp, text: 'Trusted by 200+ Organizations' },
    { icon: CheckCircle, text: 'ISO Certified Services' }
  ];

  return (
    <section id="about" className="py-20 bg-gray-50 dark:bg-gray-900">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Image Side */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://images.unsplash.com/photo-1600880292089-90a7e086ee0c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwxfHx0ZWFtJTIwY29sbGFib3JhdGlvbnxlbnwwfHx8fDE3NjA0OTM2MDl8MA&ixlib=rb-4.1.0&q=85"
                alt="Team collaboration"
                className="w-full h-[500px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-blue-900/50 to-transparent"></div>
            </div>
            {/* Floating Card */}
            <div className="absolute -bottom-0 -right-0 bg-white dark:bg-gray-800 rounded-xl shadow-xl p-6 max-w-xs hidden lg:block">
              <div className="flex items-center space-x-4">
                <div className="w-12 h-12 bg-emerald-100 dark:bg-emerald-900 rounded-lg flex items-center justify-center">
                  <Award className="w-6 h-6 text-emerald-600" />
                </div>
                <div>
                  <div className="text-2xl font-bold text-gray-900 dark:text-white">10+</div>
                  <div className="text-sm text-gray-600 dark:text-gray-400">Industry Awards</div>
                </div>
              </div>
            </div>
          </div>

          {/* Content Side */}
          <div>
            <div className="inline-block bg-blue-100 dark:bg-blue-900 text-blue-600 dark:text-blue-300 px-4 py-2 rounded-full text-sm font-semibold mb-6">
              About Us
            </div>
            <h2 className="text-4xl font-bold text-gray-900 dark:text-white mb-6">
              Trusted Leader in Integrated Facility Management
            </h2>
            <p className="text-lg text-gray-700 dark:text-gray-300 mb-6 leading-relaxed">
              With over three decades of expertise, Assure FM Services is a trusted leader in integrated facility management. We deliver world-class solutions in O&M technical (MEP), housekeeping, security, and administrative services — ensuring seamless operations and long-term value for corporates and industries.
            </p>
            <p className="text-base text-gray-600 dark:text-gray-400 mb-8 leading-relaxed">
              Our commitment to excellence, innovation, and client satisfaction has made us the preferred partner for organizations seeking reliable, comprehensive facility management solutions.
            </p>

            {/* Highlights */}
            <div className="grid sm:grid-cols-2 gap-4">
              {highlights.map((item, index) => {
                const Icon = item.icon;
                return (
                  <div
                    key={index}
                    className="flex items-center space-x-3 bg-white dark:bg-gray-800 p-4 rounded-xl shadow-sm hover:shadow-md transition-shadow duration-300"
                  >
                    <div className="w-10 h-10 bg-emerald-100 dark:bg-emerald-900 rounded-lg flex items-center justify-center flex-shrink-0">
                      <Icon className="w-5 h-5 text-emerald-600 dark:text-emerald-400" />
                    </div>
                    <span className="text-sm font-medium text-gray-700 dark:text-gray-300">
                      {item.text}
                    </span>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};